import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Feature' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: 'inherit',
        userSelect: 'none'
    },
    title: {
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '24px',
        color: 'inherit',
        textDecoration: 'underline'
    },
    icon: {
        cursor: 'help',
        width: 16,
        height: 16,
        color: '#8E8E8E'
    }
});
